export default __webpack_public_path__ + "static/media/lodasoft.5b4ccbf9.png";